import { useQuery } from '@apollo/client';
import { useAuth } from '@contexts/AuthContext';
import { SEARCH_COMPANIES_FILTERS } from '@gql/pros';
import { CompaniesFilter } from './useGetCompanies';

export type CompanyFilterOption = {
    value: string;
    label: string;
    count: number;
};

export type CompanyFilterRange = {
    min: number;
    max: number;
};

export type ProAvailableFilters = {
    sectors: CompanyFilterOption[];
    postalCodes: CompanyFilterOption[];
    cities: CompanyFilterOption[];
    totalJobOffersRange: CompanyFilterRange;
};

const DEFAULT_AVAILABLE_FILTERS: ProAvailableFilters = {
    sectors: [],
    postalCodes: [],
    cities: [],
    totalJobOffersRange: { min: 0, max: 0 },
};

export const useGetCompanyAvailableFilters = (
    filter: CompaniesFilter = {},
    query: string = '',
) => {
    const { user } = useAuth();

    const { data, loading } = useQuery(SEARCH_COMPANIES_FILTERS, {
        variables: { query, filter },
        skip: !user,
    });

    const availableFilters: ProAvailableFilters =
        data?.searchProFilters ?? DEFAULT_AVAILABLE_FILTERS;

    return { availableFilters, loading };
};
